import {DocumentBaseGroup} from '@/engine';
import {LocalizedString} from '@/model/types';
import {GA4_PROPERTY_MAX_LENGTH} from '@/services/analytics/analytics-types';
import {stringToClickNameAction} from '@/services/analytics/string-to-click-name-action';

const isTitleLocalizedString = (title: DocumentBaseGroup['title']): title is LocalizedString =>
  typeof title === 'object' && title !== null && 'fr' in title;

export const getAnalyticsWebViewContentDetail = ({title}: DocumentBaseGroup) => {
  if (!isTitleLocalizedString(title)) return null;
  return stringToClickNameAction(title.fr).substring(0, GA4_PROPERTY_MAX_LENGTH);
};
